module.exports = __webpack_public_path__ + "img/google-play.d9982832.png";